<style lang="less" scoped>
@import "class.less";
</style>
<template>
  <div class="class_box">
    <div>
      <div class="top">
        <img src="https://static.gmic.cn/gmicpro/onlinecourse/gaoshan.jpg" alt="">
        <div id="top_video"></div>
        <img src="https://static.gmic.cn/gmicpro/onlinecourse/courses.jpg" alt="">
        <div class="more" @click="loadmore" v-if="isMoreShow">
          <p>点击加载更多</p>
          <div class="animate-bounce-up">︾</div>
        </div>
      </div>
      <div v-if="!isMoreShow">
        <img src="https://static.gmic.cn/gmicpro/onlinecourse/2.jpg" alt="">
        <img src="https://static.gmic.cn/gmicpro/onlinecourse/3.jpg" alt="">
      </div>
      <div class="bottom">
        <p>我们深知追求科学不是终点，而是不停学习、验证、修正、演进的过程。在这个“商业过载”的社会，呼唤回归“无用之用”的科学真理，重建自由、安宁的心灵家园。<br>
        课程原价9999元，现首发预售6688元，限时加入！<br>
        联系“高小山”预留座位吧！</p>
        <img src="../../assets/images/gasa.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
let TxPlayer = window.Txplayer
let player
export default {
  data () {
    return {
      isMoreShow: true
    }
  },
  created () {
    player = new TxPlayer({
      containerId: 'top_video',
      vid: 'n05638u1l6t',
      width: '100%',
      height: screen.availHeight / 3
    })
    // console.log(self.txId)
    player.on('ready', () => {
      player.play('n05638u1l6t')
    })
  },
  mounted () {
    let self = this
    self.$nextTick(function () {
      player.play('n05638u1l6t')
    })
  },
  methods: {
    loadmore: function () {
      this.isMoreShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/class/class.vue